import PasswordChangeForm from './Components/PasswordChangeForm'

export default PasswordChangeForm
